<template>
    <div v-if="ReviewUrl">
        <a
            :href="ReviewUrl"
            :target="normalizedLinkTarget"
            @click="handleClickEvent()">
            <span>
                {{ reviewCount }}
            </span>
            {{ LinkText }}
        </a>
    </div>
</template>

<script>
    import RateTableService from '../services/lender-detail-service';

    export default {
        props: {
            contentKeyForReviews: {
                default: '',
            },
            linkText: {
                default: 'Reviews',
            },
            reviewCount: {
                default: 0,
            },
            linkTarget: {
                default: '_blank',
            },
        },
        data() {
            return {
                ReviewUrl: '',
                LinkText: this.linkText,
            };
        },
        methods: {
            handleClickEvent() {
                this.$emit('click', true);
            },
        },
        computed: {
            normalizedLinkTarget() {
                return this.linkTarget.trim().toLowerCase();
            },
        },
        mounted() {
            if (this.contentKeyForReviews && this.contentKeyForReviews.toString().length > 0) {
                RateTableService.getDetailsByLendercode(this.contentKeyForReviews).then((response) => {
                    this.ReviewUrl = response;
                });
            }
        },
    };
</script>
